<template>
    <div>
        <v-card flat rounded="0">
            <v-card-title primary-title>
                <v-row dense justify="space-between">
                    <v-col cols="12" sm="8">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            :class="`primary--text text-overline ml-2 ${
                                $vuetify.breakpoint.xs ? 'text-center' : ''
                            }`"
                        >
                            Tramitaciones en curso y finalizadas
                        </div>
                        <div
                            v-else
                            class="font-weight-light primary--text text-h4 ml-2"
                        >
                            Tramitaciones en curso y finalizadas
                        </div>
                    </v-col>
                    <v-col
                        sm="4"
                        cols="12"
                        :class="`d-flex align-center ${
                            $vuetify.breakpoint.xs
                                ? 'justify-center'
                                : 'justify-end'
                        }`"
                    >
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table
                :headers="headers"
                :items="filteredTramitacionesOfertas"
                :itemClass="getRowClass"
                :search="search"
            >
                <template v-slot:item.telefonos_portados="{ item }">
                    <v-tooltip
                        v-if="item.telefonos_portados"
                        max-width="470px"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                class="d-flex justify-space-between"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <div>
                                    {{ item.telefonos_portados.substr(0,9) }}
                                    ...
                                </div>
                                <v-icon>mdi-message-reply-text-outline</v-icon>
                            </div>
                        </template>
                        <span class="pa-2 text-justify">{{
                            item.telefonos_portados
                        }}</span>
                    </v-tooltip>
                </template>
                <template v-slot:item.ultimo_comentario="{ item }">
                    <v-tooltip
                        v-if="item.ultimo_comentario"
                        max-width="470px"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <div
                                class="d-flex justify-space-between"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <div>
                                    {{ item.ultimo_comentario.substr(0, 21) }}
                                    ...
                                </div>
                                <v-icon>mdi-message-reply-text-outline</v-icon>
                            </div>
                        </template>
                        <span class="pa-2 text-justify">{{
                            item.ultimo_comentario
                        }}</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <v-row class="d-flex">
                <v-col cols="12" md="6">
                    <PieChart :chart-data="pieData" :options="optionsPieChart" />
                </v-col>
                <v-col cols="12" md="6">
                    <PieChart :chart-data="pieData2" :options="optionsPieChart" />
                </v-col>
                <v-col cols="12" md="6">
                    <PieChart :chart-data="pieData3" :options="optionsPieChart" />
                </v-col>
                <v-col cols="12" md="6">
                    <PieChart :chart-data="pieData4" :options="optionsPieChart" />
                </v-col>
            </v-row>
            </v-card-text>
        </v-card>
        <v-btn-toggle
            class="no-background my-1"
            multiple
            v-model="blockedFilter"
        >
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="btn-round"
                        fixed
                        style="right: 85px"
                        v-on="on"
                        v-bind="attrs"
                        color="white"
                        bottom
                        right
                        fab
                        x-large
                        depressed
                        active-class="red"
                        value="1"
                    >
                        <v-icon :color="!blockedFilter.includes('1') ? 'black' : 'white'">mdi-lock</v-icon>
                    </v-btn>
                </template>
                <span>Bloqueado</span>
            </v-tooltip>

            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="btn-round"
                        fixed
                        style="right: 170px"
                        v-on="on"
                        v-bind="attrs"
                        color="white"
                        bottom
                        right
                        fab
                        x-large
                        depressed
                        active-class="success"
                        value="0"
                    >
                        <v-icon :color="!blockedFilter.includes('0') ? 'black' : 'white'">mdi-lock-open-variant</v-icon>
                    </v-btn>
                </template>
                <span>No Bloqueado</span>
            </v-tooltip>
        </v-btn-toggle>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import PieChart from '@/components/GerenciaTeletrabajo/Stats/PieChart.js';


export default {
	name: 'tramitacionesOfertas',
    data: () => ({
        blockedFilter: [],
        optionsPieChart: {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                position: 'left',
				align: 'center',
				fullSize: false,
				labels: {
					font: {
					size: 12
					},
					padding: 10
				},
				maxWidth: 9999
            },
        },
        headers: [
            // { text: 'bloqueado', value: 'bloqueado' },
            { text: 'estado', value: 'estado' },
            { text: 'estado_rx', value: 'estado_rx' },
            // { text: 'fechaBloqueo', value: 'fechaBloqueo' },
            { text: 'fecha_backoffice', value: 'fecha_backoffice' },
            { text: 'fecha_last_estado', value: 'fecha_last_estado' },
            // { text: 'id', value: 'id' },
            // { text: 'idOrden', value: 'idOrden' },
            // { text: 'idUsuarioBloqueo', value: 'idUsuarioBloqueo' },
            // { text: 'id_vodafone', value: 'id_vodafone' },
            // { text: 'isOffer', value: 'isOffer' },
            { text: 'nif', value: 'nif' },
            { text: 'offerId', value: 'offerId' },
            { text: 'robinson', value: 'robinson' },
            { text: 'segmento_vf', value: 'segmento_vf' },
            { text: 'sfid', value: 'sfid' },
            { text: 'subestado', value: 'subestado' },
            // { text: 'subtype', value: 'subtype' },
            { text: 'telefono_contacto', value: 'telefono_contacto' },
            { text: 'telefonos_portados', value: 'telefonos_portados', width: '150px' },
            // { text: 'tipo_gestion', value: 'tipo_gestion' },
            { text: 'tipo_tramitacion', value: 'tipo_tramitacion' },
            { text: 'tipologia', value: 'tipologia' },
            // { text: 'type', value: 'type' },
            { text: 'ultimo_comentario', value: 'ultimo_comentario' },
            // { text: 'usuarioBloqueo', value: 'usuarioBloqueo' },
            // { text: 'usuario_last_estado', value: 'usuario_last_estado' },
        ]
    }),
    components: {
		PieChart,
	},
    methods: {
        randomHexPastelColor() {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            const a = 0.5;
            return `rgba(${r}, ${g}, ${b}, ${a})`;
        },
        randomPastelColorArrayByLength(length) {
            const colors = [];
            for (let i = 0; i < length; i++) {
                colors.push(this.randomHexPastelColor());
            }
            return colors;
        },
        getRowClass(item){
            return item.bloqueado ? 'red lighten-3' : 'green lighten-3';
        }
    },
    computed: {
        filteredTramitacionesOfertas() {
            let res = this.tramitacionesOfertas.filter(item => {
                if (this.blockedFilter.length === 0) {
                    return true;
                }
                return this.blockedFilter.includes(String(item.bloqueado));
            });

            return res;
        },
        pieData() {
			let data = {}
			
			this.filteredTramitacionesOfertas.forEach(element => {
				if(element.estado) {
					if (data[element.estado]) {
						data[element.estado] += 1;
					} else {
						data[element.estado] = 1;
					}
				}
			});

            const colors = this.randomPastelColorArrayByLength(Object.keys(data).length)

			return {
				labels: Object.keys(data),
				datasets: [
					{
						label: Object.keys(data),
						data: Object.values(data),
						backgroundColor: colors,
						hoverOffset: 4,
					},
				],
			};
		},
        pieData2() {
			let data = {}
			
			this.filteredTramitacionesOfertas.forEach(element => {
				if(element.subestado) {
					if (data[element.subestado]) {
						data[element.subestado] += 1;
					} else {
						data[element.subestado] = 1;
					}
				}
			});

            const colors = this.randomPastelColorArrayByLength(Object.keys(data).length)

			return {
				labels: Object.keys(data),
				datasets: [
					{
						label: Object.keys(data),
						data: Object.values(data),
						backgroundColor: colors,
						hoverOffset: 4,
					},
				],
			};
		},
        pieData3() {
			let data = {}
			
			this.filteredTramitacionesOfertas.forEach(element => {
				if(element.segmento_vf) {
					if (data[element.segmento_vf]) {
						data[element.segmento_vf] += 1;
					} else {
						data[element.segmento_vf] = 1;
					}
				} else {
                    if (data['Sin segmento']) {
                        data['Sin segmento'] += 1;
                    } else {
                        data['Sin segmento'] = 1;
                    }
                }
			});

            const colors = this.randomPastelColorArrayByLength(Object.keys(data).length)

			return {
				labels: Object.keys(data),
				datasets: [
					{
						label: Object.keys(data),
						data: Object.values(data),
						backgroundColor: colors,
						hoverOffset: 4,
					},
				],
			};
		},
        pieData4() {
			let data = {}
			
			this.filteredTramitacionesOfertas.forEach(element => {
				if(element.tipologia) {
					if (data[element.tipologia]) {
						data[element.tipologia] += 1;
					} else {
						data[element.tipologia] = 1;
					}
				}
			});

            const colors = this.randomPastelColorArrayByLength(Object.keys(data).length)

			return {
				labels: Object.keys(data),
				datasets: [
					{
						label: Object.keys(data),
						data: Object.values(data),
						backgroundColor: colors,
						hoverOffset: 4,
					},
				],
			};
		},
        ...mapState('retailX', {
            tramitacionesOfertas: (state) => state.tramitacionesOfertas,
        }),
        ...mapState({
			search: (state) => state.util.navBarSearchField,
		}),
    },
    beforeCreate() {
        //this.$store.dispatch('retailX/fetchAll');
    },
};
</script>